function charmPopupSlider(classList) {

    const slider = $(classList).find('.charmPopup__carrousel:not(.slick-initialized)');
    
    slider.slick({
           infinite: true,
           slidesToShow: 1,
           slidesToScroll: 1,
           arrows: false,
           dots: false,
           draggable: true,
           adaptiveHeight: true,
           autoplay: false,
           vertical: true,
           verticalSwiping: true,
           responsive: [
              {
                 breakpoint: 767,
                 settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    vertical: false,
                    verticalSwiping: false,
                    dots: true,
                    infinite: false,
                 },
              },
           ],
      
     })
 
     //Implementing navigation of slides using mouse scroll
    slider.on('wheel', function (e) {
       e.preventDefault();
       if (e.originalEvent.deltaY < 0) {
          $(this).slick('slickPrev');
       } else {
          $(this).slick('slickNext');
       }
    });
  }
  
  function toggleCharmPopupVisibility() {
 
    const upsellEl = document.querySelectorAll('.hover-product-info .gallery-item');
 
    upsellEl.forEach(box => {       
     box.addEventListener('click', function (e) {
    //    document.querySelector('.blog-page-ar-upsell--slider').classList.add('open-inner-popup');
    //    var swiper = new Swiper('.blog-page-ar-upsell--slider', {
    //       allowTouchMove: false
    //   });
     console.log(e)
       const btnOpen =  e.target.closest('.hover-product-info');
 console.log(btnOpen.dataset.popup)
       // open popup functionality
       console.log('first')
       document.querySelector('body').classList.add('no-scroll');
       console.log('second')
       console.log(this.closest('.blog-page-ar-upsell--slider').querySelector('.charmPopupGridWrapper'))
       const charmPopup = this.closest('.blog-page-ar-upsell--slider').querySelector(`.charmPopupGridWrapper[data-popup=${btnOpen.dataset.popup}]`);
       const btnClose = charmPopup.querySelector('.charmPopup__btnClose');
 
       // refresh yotpo widget for popup product
       // window.yotpo && window.yotpo.refreshWidgets()
 
       charmPopup.classList.add('charmPopup--visible');
       document.querySelector('.klaviyoButton')?.classList.add('klaviyoButton-hide')
 
       // initialize image slider inside popup
       charmPopupSlider(`.charmPopupGridWrapper[data-popup=${btnOpen.dataset.popup}]`);
 
       // close popup functionality
       btnClose.addEventListener('click', closePopup);
       charmPopup.addEventListener('click', function (event) {
          if (event.target.classList.contains('charmPopupGridWrapper')) {
             closePopup();
          }
       });
 
       function closePopup() {
          document.querySelector('body').classList.remove('no-scroll');
          charmPopup.classList.remove('charmPopup--visible');
          document.querySelector('.klaviyoButton')?.classList.remove('klaviyoButton-hide')
       }
    });
 });
  }
  
  $(document).on("click", function(event){
     var $trigger = $(".ProductItem--Wrapper .product-info, .charmPopup, .ar-pdp-upsell__media, .ar-pdp-upsell__button, .charmPopup__carrousel, .charmPopup__info");
     if($trigger !== event.target && !$trigger.has(event.target).length){
         $(".charmPopupGridWrapper").removeClass('charmPopup--visible');
         document.querySelector("body").classList.remove('no-scroll')    
     }
  });
 
  function initPDP() {
     toggleCharmPopupVisibility();
  }
  
  window.addEventListener('DOMContentLoaded', initPDP);
  